const events = state => state.events
const event = state => state.event

export default {
  events,
  event
};
